module.exports = __webpack_public_path__ + "img/icon-paypal.a0a694c6.svg";